<template>
  <div class="concentrator-strategy-page">
    <div class="tab-head">
      <div class="item item1" :class="tabValue==='time'?'curr':''" @click="checkTab('time')">{{$t('lampStrategy.time_strategy')}}</div>
      <div class="item item2" :class="tabValue==='area'?'curr':''" @click="checkTab('area')">{{$t('lampStrategy.area_strategy')}}</div>
    </div>
    <div class="con-body">
      <strategy-time v-show="tabValue==='time'" ref="addStrategy"></strategy-time>
      <strategy-area v-show="tabValue==='area'" ref="strategyArea"></strategy-area>
    </div>
  </div>
</template>
<script>
import strategyTime from "@/views/concentrator/strategy/time.vue"
import strategyArea from "@/views/concentrator/strategy/area.vue"
export default {
  components: { 
    strategyTime,
    strategyArea
  },
  data() {
    return {
      tabValue: 'time'
    };
  },
  methods: {
    checkTab(value) {
      this.tabValue = value
    }
  }
};
</script>

<style lang='less' scoped>
@color-primary:#0c82fe;
.concentrator-strategy-page{
  .tab-head{
    display: flex;
    align-items: center;
    .item{
      height: 56px;
      display: flex;
      align-items: center;
      color: #666;
      padding:6px 50px 0;
      font-size: 16px;
      padding-top: 6px;
      position: relative;
      box-sizing: border-box;
      cursor: pointer;
      &.curr{
        color: @color-primary;
        background-color: #ffffff;
      }
    }
  }
}
</style>
